export enum CommonModalTemplatesEnum {
  MAX_ORDER_VALUE = 'max-order-value',
  NUMBER_VERIFICATION = 'number-verification',
  NUMBER_VERIFICATION_SMS = 'number-verification-sms',
  NUMBER_VERIFICATION_SMS_SENT_AGAIN = 'number-verification-sms-sent-again',
  NUMBER_VERIFICATION_FAILURE = 'number-verification-failure',
  CONTACT_REQUEST_MODAL = 'contact-request-modal',
  CCDS_CONTACT_SUCCESS = 'ccds-contact-success',
  CCDS_CONTACT_FAILURE = 'ccds-contact-failure',
  INCORRECT_PASSWORD = 'number-verification-sms-error',
  LOTTERY_NUMBER_FAILURE = 'lottery-number-failure',
  DRAWING_NEW_NUMBERS = 'drawing-new-numbers',
  REMOVE_SET_CONFIRMATION_MODAL = 'remove-set-confirmation-modal',
  SLOT_DETAILS_MODAL = 'slot-details-modal',
  CONFIRMATION_CART_EMAIL = 'confirmation-cart-email',
  CONTRACT_DETAILS_MODAL = 'contract-details-modal',
  INTERNET_DETAILS_MODAL = 'internet-details-modal',
  MODAL_CHECK_AGREEMENTS_COMPLETE = 'modal-check-agreements-complete',
  LOGOUT_MODAL = 'logout-modal',
  CART_CLEAR_CONFIRMATION_MODAL = 'cart-clear-confirmation-modal',
  ADDONS_MODAL = 'addons-modal',
  NUMBER_DELETE_CONFIRMATION = 'number-delete-confirmation',
  AGREEMENTS_UNLIMITED_GB_MODAL = 'agreements-unlimited-gb-modal',
  MODAL_LOADER = 'modal-loader',
  CREDIT_CHECK_LOADER = 'credit-check-loader',
  POS_MODAL = 'pos-modal',
  INFORMATION_ON_LIMITS = 'information-on-limits',
  NIP_BLACKLISTED = 'nip-blacklisted',
  SHOW_MORE_ONLINE_AUTHENTICATION = 'show-more-online-authentication',
  SHOW_MORE_M_ID_AUTHENTICATION = 'show-more-m-id-authentication',
  DATA_CHANGE_CONFIRMATION = 'data-change-confirmation',
  CONTACT_REQUEST_VIRGIN_MODAL = 'contact-request-virgin-modal',
  CONTACT_REQUEST_INPUT_VIRGIN_MODAL = 'contact-request-input-virgin-modal',
  VIRGIN_CCDS_CONTACT_SUCCESS = 'virgin-ccds-contact-success',
  SHOW_MORE_ID_TYPE_INFORMATION = 'show-more-id-type-information',
  PROVINCE_SELECT = 'province-select',
}
